// CacheKey 032e18cc81ddcd942be149ed79c09018
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-DICTIONARY_TEST_PROVIDER": {
    simple_form: {
      labels: {
        encounter: {
          encounter_id: "Episode ID",
          encounter_class: "Episode Class",
          surgical_encounter_status: "Surgical Episode Status"
        }
      },
      options: {
        data_exchange_file_import: {
          roundable_object_type: {
            patient: "Members",
            unit: "Units",
            room: "Rooms"
          }
        }
      }
    }
  }
}

